import { ProfilesRegisterTemplate } from "../../Templates/ProfilesRegisterTemplate";

export const ProfilesRegister = () => {
  return <ProfilesRegisterTemplate />;
};
